module.exports = __webpack_public_path__ + "img/fj.6383c59d.jpg";